window.popup=function(name){
    $(".mask").height($(document).height()).show();
    $(".popup").show();
    $(".ent").hide().eq(name).show()
};
window.popupClose=function(){
    $(".mask ,.ent ,.popup").hide();
};
